import clsx from 'clsx';
import styles from './TertiaryAction.module.css';

export function TertiaryActionButton({
  ariaLabel,
  children,
  className = '',
  onClick,
  onMouseDown,
  variant = 'default',
  type = 'button',
  disabled = false,
  ...rest
}) {
  return (
    <button
      {...rest}
      aria-label={ariaLabel}
      className={clsx(
        styles.action,
        variant === 'plain' && styles.plain,
        disabled && styles.disabled,
        className,
      )}
      onClick={onClick}
      onMouseDown={onMouseDown}
      type={type}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
